import { STATIC_FAQ } from "./staticFaq";

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  setBotMessage = (message, options = {}) => {
    const botMessage = this.createChatBotMessage(message, options);

    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  handleFaqSelection = (faqId) => {
    const selectedFaq = STATIC_FAQ.find((faq) => faq.id === faqId);

    if (!selectedFaq) {
      this.handleUnknownQuestion();
      return;
    }

    this.setBotMessage(selectedFaq.answer, { withAvatar: true });
  };

  handleUnknownQuestion = () => {
    this.setBotMessage(
      "I can help with registration, login, account verification, arbitration request submission, password reset, and support contact.",
      { withAvatar: true, widget: "quickOptions" },
    );
  };
}

export default ActionProvider;
